import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgBadgeIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      data-color="color-2"
      d="M13.876 36.135 5.097 54.57a1 1 0 0 0 1.014 1.423l8.375-.93 4.667 7.466A.996.996 0 0 0 20 63l.048-.001c.361-.017.685-.229.847-.552l8.782-17.564c-6.405-.645-12.037-3.933-15.801-8.748zM50.124 36.135l8.779 18.436a1 1 0 0 1-1.014 1.423l-8.375-.93-4.667 7.466A.997.997 0 0 1 44 63l-.048-.001a1.002 1.002 0 0 1-.847-.552l-8.782-17.564c6.405-.645 12.037-3.933 15.801-8.748z"
    />
    <path d="M32 1c-11.579 0-21 9.42-21 21s9.421 21 21 21 21-9.42 21-21S43.579 1 32 1zm10.692 19.528L38.035 25l1.043 6.372a1 1 0 0 1-1.459 1.043l-5.692-3.048-5.737 2.961a1 1 0 0 1-1.444-1.065l1.14-6.356-4.589-4.542a.998.998 0 0 1 .567-1.701l6.396-.879 2.901-5.769c.171-.341.502-.575.901-.551.381.003.727.222.893.564l2.813 5.812 6.383.977a.998.998 0 0 1 .541 1.71z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgBadgeStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgBadgeIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const BadgeIcon: any = SvgBadgeStyle;
export default BadgeIcon;
